import useragent from '@common/useragent'
import { call, uriSuishouji } from './bridge'
import { compare } from './version'

const ssjFontColor = '492000'
const ssjBgColor = 'fad239'
const knBgColor = 'fb814b'

export default ({ cancel = false, needKaniu = false } = {}) => {
  // 这里所有大版本号+1，以取消透明导航栏
  if (useragent.isKaniu) {
    const featureVersion = useragent.isIOS ? '8.9.1' : '8.9.3'
    if (!compare(featureVersion)) {
      return
    }
  } else if (useragent.isSuishouji) {
    const featureVersion = useragent.isIOS ? '11.8.4' : '11.4.5.0'
    if (!compare(featureVersion)) {
      return
    }
  } else {
    return
  }
  if (cancel) {
    if (useragent.isKaniu && needKaniu) {
      call('cardniu://finance/barStyle?opt=0')
    } else if (useragent.isSuishouji) {
      call(uriSuishouji('barStyle', { opt: 0 }))
    }
    return
  }
  if (useragent.isKaniu && needKaniu) {
    const barObj = {
      starting_offset: 0,
      end_offset: 100,
      background: {
        starting_color: `00${knBgColor}`,
        end_color: `ff${knBgColor}`,
      },
      isFullScreen: true
    }
    call(`cardniu://finance/barStyle?opt=1&config=${encodeURIComponent(JSON.stringify(barObj))}`)
  } else if (useragent.isSuishouji) {
    const barObj = {
      starting_offset: 0,
      end_offset: 100,
      starting_color: `ff${ssjFontColor}`,
      end_color: `ff${ssjFontColor}`,
      background: {
        starting_color: `00${ssjBgColor}`,
        end_color: `ff${ssjBgColor}`,
      },
      isFullScreen: true
    }
    call(uriSuishouji('barStyle', { opt: 1, config: barObj }))
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestBarStyle.js